import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ICreateRedTeamSessionRequest,
  ICreateRedTeamSessionResponse,
  IRedTeamSession,
} from 'src/app/models/api/red-team/red-team-session.model';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class RedTeamHttpService {
  private readonly _baseUrl = 'governance/redteam';

  constructor(private readonly _httpService: HttpService) {}

  getSessions(): Observable<IRedTeamSession[]> {
    const url = `${this._baseUrl}/sessions`;
    return this._httpService.get<IRedTeamSession[]>(url);
  }

  getSession(sessionId: string): Observable<IRedTeamSession> {
    const url = `${this._baseUrl}/sessions/${sessionId}`;
    return this._httpService.get<IRedTeamSession>(url);
  }

  createSession(body: ICreateRedTeamSessionRequest): Observable<ICreateRedTeamSessionResponse> {
    const url = `${this._baseUrl}/sessions`;
    return this._httpService.post<ICreateRedTeamSessionRequest, ICreateRedTeamSessionResponse>(url, body);
  }

  exportSessionCsv(sessionId: string): Observable<{ fileUrl: string }> {
    const url = `${this._baseUrl}/sessions/${sessionId}/export`;
    return this._httpService.get<{ fileUrl: string }>(url);
  }
}
